<div style="display: flex; align-items: center; width: 100%;">
    <span style="flex-grow: 1; text-align: center; padding-left:3rem;font-size: 15px;text-transform: uppercase;">{{ params.displayName }}</span>
    <button class="btn btn-danger m-0" (click)="buttonClick()">
        <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
</div>

  
